<template>
  <div>
    <!-- When ProductStatus is 'Coming Soon' -->
    <div
      v-if="getProductStatus && getProductStatus[0].ProductStatus === 'Coming Soon'"
      class="bannerContainer"
    >
      <div class="contentBody_comingSoon">
        <h1>{{ getProductStatus[0].ProductStatus }}</h1>
      </div>
    </div>

    <!-- When ProductStatus is 'Discontinued' -->
    <div
      v-else-if="getProductStatus && getProductStatus[0].ProductStatus === 'Discontinued'"
      :id="deviceType + 'bannerContainerPdp'"
      class="bannerContainer"
      
    >
      <div class="contentBody_discontinued">
        <h1>{{ getProductStatus[0].ProductStatus }}</h1>
      </div>
    </div>

    <!-- If BannerData exists -->
    <div
      v-else-if="getBannerData()"
      :id="deviceType + 'bannerContainerPdp'"
      class="bannerContainer"
      :style="cssVars"
    >
      <div class="contentBody">
        <h1>{{ getBannerData().BannerText }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    deviceType: {
      Type: String,
      default: ""
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    getBannerData() {
      if (this.getProductBanner) {
        return this.getProductBanner;
      } else if (this.getEnhancedProductBanner) {
        return this.getEnhancedProductBanner;
      } else {
        return null;
      }
    }
  },
  computed: {
    ...mapGetters("product", ["getProductBanner", "getProductStatus"]),
    ...mapGetters("enhancedproduct", ["getEnhancedProductBanner"]),
    cssVars() {
      if (this.getBannerData()) {
        return {
          "--bg-color": this.getBannerData().BannerColor,
          "--text-color": this.getBannerData().TextColor,
          "--border-color": this.getBannerData().BorderColor
        };
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bannerContainer {
  max-width: 50%;
  @include media-breakpoint-up(md) {
    position: absolute;
    height: 4em;
    margin: 10px 0 0 0;
    right: 0;
  }

  @include media-breakpoint-down(sm) {
    display: flex;
  }
}

.contentBody {
  background: var(--bg-color);
  border: 1px solid var(--border-color);
  padding: 5px 10px 2px;
  @include media-breakpoint-up(md) {
    position: relative;
    z-index: 1;
    right: 0;
  }

  @include media-breakpoint-down(sm) {
    margin-bottom: 25px;
  }
}

.contentBody h1 {
  margin: 0;
  font-size: 12px;
  color: var(--text-color);
  font-family: $font-family-sans-serif-bold;
}

.contentBody_comingSoon {
  background: #d7efeb;
  border: 1px solid $teritiary;
  padding: 2px 8px;
  @include media-breakpoint-up(md) {
    position: relative;
    z-index: 1;
    right: 0;
  }

  @include media-breakpoint-down(sm) {
    margin-bottom: 25px;
  }
}

.contentBody_comingSoon h1 {
  margin: 0;
  font-size: 12px;
  color: $black85;
  font-family: $heading;
  font-weight: bold;
  line-height: 18px;
  letter-spacing: 0.6px;
}

.contentBody_discontinued {
  background: #CC0000; 
  border: 1px solid #CC0000;
  padding: 5px 10px 2px;
  color: white;
  @include media-breakpoint-up(md) {
    position: relative;
    z-index: 1;
    right: 0;
  }

  @include media-breakpoint-down(sm) {
    margin-bottom: 25px;
  }
}

.contentBody_discontinued h1 {
  margin: 0;
  font-size: 12px;
  color: white;
}
</style>
